export const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return "";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};
